import React from "react";

import { AnchorBlock as Value } from "@reactivated";

interface Props {
    value: Value;
}

export const AnchorBlock = (props: Props) => <span id={props.value}></span>;
